import React from "react";
import { PageLayout } from "../../components";
import ConditionQuestionCompactView from "./ConditionQuestionCompactView";
import SubmitButton from "../../components/SubmitButton/SubmitButton";
import { YourCarConditionHelmet } from "../../components/SellHelmets";
import {
  QuestionIds,
  questionPresentationContent
} from "../../data/QuestionPresentation";
import { BodyworkQuestionCompact } from "./components/BodyworkQuestionCompact";
import { ModificationQuestionCompact } from "./components/ModificationQuestionCompact";
interface IConditionQuestionsProps {
  bodyworkQuestion: Question;
  conditionQuestions: Question[];
  onSubmit: () => void;
  questionsAndAnswers: ChosenAnswer[];
  isContinueClicked: boolean;
  modificationQuestion?: any;
}

export default function ConditionQuestionsCompactView({
  bodyworkQuestion,
  conditionQuestions,
  modificationQuestion,
  onSubmit,
  questionsAndAnswers,
  isContinueClicked
}: IConditionQuestionsProps) {
  const exceptionQuestionsIds = [QuestionIds.MODIFICATIONS];
  return (
    <>
      <YourCarConditionHelmet />
      <PageLayout>
        <PageLayout.Header title="Your car’s condition" step={4} />
        <PageLayout.CompactView>
          <div className="md:ch-width--8">
            <div className="ch-pt--8 ch-pb--6">
              <BodyworkQuestionCompact
                question={bodyworkQuestion}
                subtitle={
                  questionPresentationContent[bodyworkQuestion.id].pageTitle
                }
              />
            </div>
            {conditionQuestions?.map((question: Question) =>
              exceptionQuestionsIds.includes(question.id) ? null : (
                <ConditionQuestionCompactView
                  key={question.id}
                  question={question}
                  storedAnswer={questionsAndAnswers[question.id]}
                  subtitle={
                    questionPresentationContent[question.id]
                      ? questionPresentationContent[question.id].pageTitle
                      : ""
                  }
                  isContinueClicked={isContinueClicked}
                />
              )
            )}
            {modificationQuestion && <ModificationQuestionCompact
              question={modificationQuestion}
              subtitle={
                questionPresentationContent[QuestionIds.MODIFICATIONS].pageTitle
              }
            />}
          </div>
          <SubmitButton onSubmit={onSubmit} buttonText="Continue" />
        </PageLayout.CompactView>
      </PageLayout>
    </>
  );
}
